import { render, staticRenderFns } from "./GoToResources.vue?vue&type=template&id=731b34ba&scoped=true&"
import script from "./GoToResources.vue?vue&type=script&lang=js&"
export * from "./GoToResources.vue?vue&type=script&lang=js&"
import style0 from "./GoToResources.vue?vue&type=style&index=0&id=731b34ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731b34ba",
  null
  
)

export default component.exports